import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { statesArray } from '@src/global/statesArray';

import './AvailabilityTable.scss';

const AvailabilityTable = (props) => {
    const { currentItem } = props;
    let availableStates = [];
    let comingSoonStates = [];
    let relaunchedStates = [];

    if (currentItem) {
        availableStates = (currentItem.map_available_states || []).map((s) => s.abbreviation);
        comingSoonStates = (currentItem.map_coming_soon_states || []).map((s) => s.abbreviation);
        relaunchedStates = (currentItem.map_relaunched_states || []).map((s) => s.abbreviation);
    }

    return (
        <Row className="map-table-container-row">
            <Col className="map-table-container-col">
                <Card>
                    <Card.Header>
                        <div className="map-table-legend">
                            <span className="available">
                                <img src="/img/availability-map/check_green_icon.svg" alt="Available" />
                                <span>Available</span>
                            </span>
                            <span className="not-available">
                                <img src="/img/availability-map/x_icon.svg" alt="Not Available / Limited" />
                                <span>Not Available / Limited</span>
                            </span>
                            {
                                comingSoonStates.length > 0 && (
                                    <span className="coming-soon">
                                        <img src="/img/availability-map/coming_soon_icon.svg" alt="Coming Soon" />
                                        <span>Coming Soon</span>
                                    </span>
                                )
                            }
                            {
                                relaunchedStates.length > 0 && (
                                    <span className="relaunched">
                                        <img src="/img/availability-map/calendar_icon.svg" alt="Relaunched" />
                                        <span>Relaunched</span>
                                    </span>
                                )
                            }
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <ul>
                            {
                                statesArray.sort((a, b) => a.name.localeCompare(b.name)).map((thisState) => {
                                    const {
                                        abbreviation,
                                        name,
                                    } = thisState;

                                    const isAvailable = availableStates.includes(abbreviation);
                                    const isComingSoon = comingSoonStates.includes(abbreviation);
                                    const isRelaunched = relaunchedStates.includes(abbreviation);

                                    let availability = 'Not Available / Limited';
                                    const availabilityClassNames = classNames({
                                        'availability': true,
                                        'available': isAvailable,
                                        'not-available': !isAvailable,
                                        'coming-soon': isComingSoon,
                                        'relaunched': isRelaunched,
                                    });

                                    if (isAvailable) {
                                        availability = 'Available';
                                    } else if (isComingSoon) {
                                        availability = 'Coming Soon';
                                    } else if (isRelaunched) {
                                        availability = 'Relaunched';
                                    }

                                    return (
                                        <li key={name}>
                                            <span className={availabilityClassNames}>{ availability }</span>
                                            <span className="state-name">{ name }</span>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

AvailabilityTable.propTypes = {
    currentItem: PropTypes.object,
};

export default AvailabilityTable;
